import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { canWrite } from '../lib/canWrite';

/**
 * Phase 18 — Read-only notice shown above action surfaces when the current
 * user has not yet verified their email. Admins are exempt (see canWrite).
 */
const ReadOnlyNotice = ({ action = 'perform this action', className = '' }) => {
  const { user } = useAuth();
  if (canWrite(user)) return null;

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-amber-500/40 bg-amber-500/15 p-3 text-xs text-foreground ${className}`}
      data-testid="readonly-notice"
    >
      <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 gold-text" />
      <p className="leading-snug">
        Your account is in <span className="font-semibold gold-text">read-only</span> mode. Verify your email to {action}.{' '}
        <Link
          to="/settings"
          className="font-semibold underline underline-offset-2 gold-text hover:text-amber-200"
          data-testid="readonly-notice-link"
        >
          Enter your code
        </Link>
      </p>
    </div>
  );
};

export default ReadOnlyNotice;
